<template>
  <div>
    <!-- 卡片 -->
    <div ref="cardRef" class="card mt-1">
      <div class="card-body">
        <div class="d-flex justify-content-center align-items-center">
          <div>Withdraw funds now</div>
        </div>

        <!-- Step 1 -->
        <div v-if="currentStep === 1">
          <div class="p-2 transaction-title text-center">
            Select individual transactions or select all
          </div>
          <div class="mt-5 p-2">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <DateRangePicker />
              </div>
              <div>
                <div class="d-flex align-items-center gap-2 select-all-block select-all">
                  <label class="select-all-label mb-0">Select all</label>
                  <input
                    type="checkbox"
                    class="select-all-checkbox"
                    v-model="selectAll"
                  />
                </div>
              </div>
            </div>
            <hr />
            <!-- ★ 大於 400 禁止勾選，負值自動勾選且不得取消 -->
            <div
              v-for="(transaction, index) in paginatedTransactions"
              :key="transaction.id"
            >
              <div class="d-flex justify-content-between align-items-center">
                <div>{{ transaction.transaction_date_time }}</div>
                <div class="d-flex align-items-center gap-2 select-all-block select-all">
                  {{ formatAmount(transaction.transaction_total) }}
                  <input
                    type="checkbox"
                    class="select-all-checkbox"
                    v-model="transaction.checked"
                    :disabled="transaction.transaction_total > 400 || transaction.transaction_total < 0"
                  />
                </div>
              </div>
              <hr style="width: 100%; margin: 8px 0;" />
            </div>
          </div>
        </div>

        <!-- Step 2 (Review and confirm) -->
        <div v-else-if="currentStep === 2">
          <div class="p-2 transaction-title text-center">
            Review and confirm
          </div>
          <div class="mt-5 p-3">
            <div class="withdraw-text">Total funds to withdraw</div>
            <div class="text-total mt-2">${{ formatAmount(withdrawStore.checkData.total_funds_to_withdraw) }}</div>
            <hr />
            <div class="withdraw-text">From</div>
            <div class="text-from mt-2">{{ withdrawStore.checkData.from }}</div>
            <hr />
            <div class="withdraw-text">To</div>
            <div class="text-from mt-2">{{ withdrawStore.checkData.to }}</div>
            <div class="mt-3" v-if="withdrawStore.checkData.to_account_type === '1'">
              <div class="bank-account text-left">Bank account:</div>
              <div class="bank-text mt-2">{{ withdrawStore.checkData.to_account_no }}</div>
            </div>
            <div class="mt-5 p-3 d-flex align-items-center justify-content-center flex-column h-50 incorrect-text">
              <div>Incorrect Bank account or PayID details?</div>
              <div>
                Go to your<a href="#" @click="goToProfiile">profile page</a> to change your nominated account.
              </div>
            </div>
          </div>
        </div>

        <!-- Step 3: Loading -->
        <div v-else-if="currentStep === 3" class="loading-screen">
          <h5 class="modal-title text-center mb-4">Withdraw funds now</h5>
          <div class="spinner"></div>
        </div>

        <!-- Step 4: Success -->
        <div v-else-if="currentStep === 4" class="success-screen">
          <div class="text-center">
              <div class="success-icon">✔</div>
              <h2 class="success-title">Withdrawal successful</h2>
              <div class="success-amount">${{ formatAmount(withdrawStore.confirmData.payment_amount) }}</div>
              <div class="success-date">{{ nowTime }}</div>
          </div>
          <hr />
          <div class=" text-left">
              <div class="to-label">To</div>
              <div class="to-name">{{ withdrawStore.confirmData.account_name }}</div>
              <div class="bank-account-label mt-2">Bank account:</div>
              <div class="bank-account-value">{{ withdrawStore.confirmData.account_no }}</div>
          </div>
          <hr />
          <div class=" text-left">
              <div class="fee-label">Withdrawal fee</div>
              <div class="fee-amount">${{ formatAmount(withdrawStore.confirmData.withdrawal_fee) }}</div>
          </div>
        </div>

        <!-- Step 5: Fail -->
        <div v-else-if="currentStep === 5" class="fail-screen text-center">
          <div class="fail-icon">✗</div>
          <h2 class="fail-title text-center">Withdrawal unsuccessful</h2>
          <div class="fail-text">
            Sorry, we were unable to complete your withdrawal. Please contact our
            customer service team for further information.
          </div>
          <div class="contact-info mt-5">
            <div>
              <div class="d-flex justify-content-center align-items-center">
                  <img src="@/assets/images/driver/phone.png" alt="Phone" class="phone-icon" />
                  <div>
                      <strong>Call</strong> – 0280 060 696
                  </div>
              </div>
            </div>
            <div>
              <div class="mt-2 d-flex justify-content-center align-items-center">
                  <img src="@/assets/images/driver/sms.png" alt="SMS" class="sms-icon" />
                    <div>
                       <strong>SMS</strong> – 0466 048 009
                    </div>
              </div>
            </div>
            <div class="contact-time">(Monday to Friday 10:30am to 5pm)</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 固定 Footer -->
    <div ref="footerRef" class="footer-container">
      <!-- STEP 1 頁面：清單 & 分頁 -->
      <div v-if="currentStep === 1" class="d-flex justify-content-between align-items-center">
        <div class="pagination-left">
          <button @click="changePage(1)" :disabled="currentPage === 1">
            <img src="@/assets/images/admin/arrow/prev-end.png" alt="Prev-end" class="arrow-icon" />
          </button>
          <button @click="changePage(currentPage - 1)" :disabled="currentPage === 1">
            <img src="@/assets/images/admin/arrow/prev.png" alt="Prev" class="arrow-icon" />
          </button>
        </div>
        <div class="pagination-center">
          <span class="page-info">
            Page
            <input
              type="number"
              v-model.number="currentPage"
              @change="changePage(currentPage)"
              class="page-input"
            />
            of {{ totalPages }}
          </span>
        </div>
        <div class="pagination-right">
          <button @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages">
            <img src="@/assets/images/admin/arrow/next.png" alt="Next" class="arrow-icon" />
          </button>
          <button @click="changePage(totalPages)" :disabled="currentPage === totalPages">
            <img src="@/assets/images/admin/arrow/next-end.png" alt="Next-end" class="arrow-icon" />
          </button>
        </div>
      </div>
      <hr v-if="currentStep === 1" class="mt-2 mb-2" />

      <div v-if="currentStep === 1">
        <div class="mt-2 d-flex justify-content-between align-items-center">
          <div>Transactions</div>
          <div>{{ selectedCount }}</div>
        </div>
        <div class="mt-2 d-flex justify-content-between align-items-center">
          <div>Transactions subtotal</div>
          <div>${{ formatAmount(selectedSubTotal) }}</div>
        </div>
        <div class="mt-2 d-flex justify-content-between align-items-center">
          <div>Fees & refunds*</div>
          <div>${{ formatAmount(selectedFees) }}</div>
        </div>
        <div class="mt-2 d-flex justify-content-between align-items-center">
          <div class="total-text">Total</div>
          <div class="total-text">${{ formatAmount(selectedTotal) }}</div>
        </div>
        <div class="mt-1 p-3 d-flex align-items-center justify-content-center flex-column h-10">
          <div class="note-text">
            * The ${{ formatAmount(withdrawStore.feesAndRefunds) }} fee/reversal for this withdrawal is included in fees & refunds.No fee applies for withdrawal to card.
          </div>
        </div>
      </div>

      <!-- 底部按鈕區 -->
      <div class="d-flex justify-content-between align-items-center mt-2">
        <div v-if="currentStep === 1 || currentStep === 2">
          <button class="btn btn-cancel" @click="$emit('close')">Cancel</button>
        </div>

        <!-- Step 1: Next -->
        <div v-if="currentStep === 1">
          <button class="btn btn-green btn-step" @click="goToStep2">
            Next
            <img class="btn-icon" src="@/assets/images/driver/next.png" />
          </button>
        </div>

        <!-- Step 2: Back + Confirm -->
        <div v-if="currentStep === 2">
          <button class="btn btn-green btn-step" @click="backToStep1">
            <img class="btn-icon" src="@/assets/images/driver/back.png" />
            Back
          </button>
        </div>
        <div v-if="currentStep === 2">
          <button class="btn btn-green btn-step" @click="confirmWithdrawal">
            Confirm
          </button>
        </div>
      </div>
      <div v-if="currentStep === 4 || currentStep === 5" class="d-flex justify-content-center">
          <button class="btn btn-green btn-ok" @click="$emit('close')">
            OK
          </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, watch, nextTick, computed } from 'vue'
import { useWithdrawStore } from '@/store/driver/withdraw'
import { useDriverStore } from '@/store/driver/driver'
import { useRouter } from 'vue-router'
import DateRangePicker from './dateRangePicker.vue'
import Swal from 'sweetalert2'

const router = useRouter()
const withdrawStore = useWithdrawStore()
const driverStore = useDriverStore()  
// 頁數相關
const nowTime = ref();
const currentPage = ref(1);
const pageItems = ref(10);
const totalEntries = computed(() => withdrawStore.totalEntries)
const totalPages = computed(() => {
  return Math.ceil(totalEntries.value / pageItems.value)
})

// 計算當前分頁可顯示的交易
const paginatedTransactions = computed(() => {
  const startIndex = (currentPage.value - 1) * pageItems.value
  const endIndex = startIndex + pageItems.value
  return withdrawStore.transactions.slice(startIndex, endIndex)
})

// 取得目前選定的帳號（enabled == 1）
const currentAccount = computed(() => {
  const driver = JSON.parse(localStorage.getItem('Driver') || '{}')
  // 從 accounts 陣列中找 enabled == 1 的帳號
  const accounts = driver?.accounts || []
  const enabledAccount = accounts.find(acc => acc.enabled == 1)
  
  return enabledAccount || null
})

const selectAll = ref(false)
// Step 頁面：1=列表, 2=Review, 3=Loading, 4=Success, 5=Fail
const currentStep = ref(1)

// 取得 card 與 footer 的 ref
const cardRef = ref(null)
const footerRef = ref(null)

// 初始化
onMounted(async() => {
  updateCardHeight()
  window.addEventListener('resize', onResize)
  // 後端直接回傳全部交易
  await withdrawStore.fetchTransactions() 
  withdrawStore.transactions.forEach(tx => {
    if (tx.transaction_total < 0) {
      tx.checked = true
    } else {
      tx.checked = false
    }
  })
})

const goToProfiile = () => {
  router.push('/profile')
}

onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize)
})

// 若 step 改變, 等 DOM 更新後重新計算 card 高度
watch(currentStep, async () => {
  await nextTick()
  updateCardHeight()
})

function onResize() {
  nextTick(() => {
    updateCardHeight()
  })
}

function updateCardHeight() {
  if (!cardRef.value || !footerRef.value) return

  const windowHeight = window.innerHeight
  const footerHeight = footerRef.value.offsetHeight
  const topOffset = 80  

  const MIN_HEIGHT = 200

  let newHeight = windowHeight - footerHeight - topOffset
  if (newHeight < MIN_HEIGHT) newHeight = MIN_HEIGHT

  cardRef.value.style.height = `${newHeight}px`
}

// 切換到 Step 2 (Review)
async function goToStep2() {
  if (selectedCount.value === 0) {
    Swal.fire({
      icon: 'warning',
      title: 'Warning',
      text: 'Please select at least one transaction to proceed.',
      confirmButtonText: 'OK'
    })
    return;
  }

  if (selectedTotal.value < 0) {
    Swal.fire({
      icon: 'warning',
      title: 'Warning',
      text: 'Payment total cannot be negative. Please adjust your selection.',
      confirmButtonText: 'OK'
    })
    return
  }

  // 收集所有勾選交易的ID
  const transactionIds = selectedTransactions.value.map(tx => tx.id);

  currentStep.value = 3

  try {
    // 呼叫後端檢查
    const res = await withdrawStore.checkWithdraw(transactionIds);

    if (res) {
      currentStep.value = 2;
    }else{
      currentStep.value = 1;
    }

  } catch (error) {
    // ★ 如果後端檢查失敗 => 中斷流程、顯示錯誤
    Swal.fire({
      icon: 'error',
      title: 'Check failed',
      text: error.message || 'Something went wrong',
    });
  }
}

// 回到 Step 1
function backToStep1() {
  currentStep.value = 1
}

// 最終確認
const confirmWithdrawal = async () => {
  // 收集所有勾選交易的ID
  const transactionIds = selectedTransactions.value.map(tx => tx.id);

  currentStep.value = 3
  try {
    // 呼叫後端檢查
    const res = await withdrawStore.confirmWithdraw(transactionIds);

    if (res) {
      currentStep.value = 4;
      nowTime.value = getAusTimeNow()
      withdrawStore.fetchWithdrawHistory()
    } else {
      currentStep.value = 5;
      withdrawStore.fetchWithdrawHistory()
    }
  } catch (error) {
    // ★ 如果後端檢查失敗 => 中斷流程、顯示錯誤
    Swal.fire({
      icon: 'error',
      title: 'Check failed',
      text: error.message || 'Something went wrong',
    });
  }
}

watch(selectAll, (newVal) => {
  withdrawStore.transactions.forEach(tx => {
    if (tx.transaction_total <= 400 && tx.transaction_total >= 0) {
      tx.checked = newVal
    } else if (tx.transaction_total < 0) {
      tx.checked = true
    } else {
      tx.checked = false
    }
  })
})

watch(
  () => withdrawStore.transactions.map(t => t.checked),
  () => {
    const checkableTxs = withdrawStore.transactions.filter(t => t.transaction_total <= 400 && t.transaction_total >= 0)
    const allChecked = checkableTxs.length > 0 && checkableTxs.every(t => t.checked)
    selectAll.value = allChecked
  },
  { deep: true }
)

// 分頁
const changePage = (page) => {
  if (page < 1) page = 1
  if (page > totalPages.value) page = totalPages.value
  currentPage.value = page
}

// 已勾選的交易
const selectedTransactions = computed(() => {
  return withdrawStore.transactions.filter(tx => tx.checked)
})

// 已勾選筆數
const selectedCount = computed(() => selectedTransactions.value.length)

// 已勾選總額
const selectedSubTotal = computed(() => {
  return selectedTransactions.value.reduce((acc, tx) => {
    return acc + Number(tx.transaction_total || 0)
  }, 0)
})

// 手續費（與電腦版 withdrawFundsButton：type === 4 不計提現手續費）
const selectedFees = computed(() => {
  
  return withdrawStore.feesAndRefunds
})

// 總金額：type === 4 時僅交易合計，否則加上手續費
const selectedTotal = computed(() => {
  const transactionsTotal = selectedTransactions.value.reduce((acc, tx) => {
    return acc + Number(tx.transaction_total || 0)
  }, 0)
  
  return transactionsTotal + selectedFees.value
})

// 取得「澳洲雪梨時區」的現在時間字串
function getAusTimeNow() {
  // 1) 先取得「以澳洲雪梨時區」為基準的當地時間字串
  const localString = new Date().toLocaleString('en-US', {
    timeZone: 'Australia/Sydney'
  });
  // 例如 "1/6/2024, 00:03:00" (實際格式依瀏覽器/系統略有不同)

  // 2) 轉成真正的 Date 物件
  const dateInSydney = new Date(localString);

  // 3) 取得「日 / 月(縮寫) / 年」
  const day = dateInSydney.getDate();
  const monthIndex = dateInSydney.getMonth(); // 0 ~ 11
  const year = dateInSydney.getFullYear();
  const monthNames = ["Jan","Feb","Mar","Apr","May","Jun",
                      "Jul","Aug","Sep","Oct","Nov","Dec"];
  const monthShort = monthNames[monthIndex];
  const dayStr = day < 10 ? '0' + day : String(day);

  // 4) 取得「時 / 分」(12小時制) + am/pm
  let hour = dateInSydney.getHours();   // 0 ~ 23
  let minute = dateInSydney.getMinutes(); // 0 ~ 59
  let ampm = 'am';
  if (hour >= 12) {
    ampm = 'pm';
    if (hour > 12) hour -= 12;
  }
  if (hour === 0) hour = 12;
  const minuteStr = minute < 10 ? '0' + minute : String(minute);

  // 5) 組裝成指定格式
  return `${dayStr} ${monthShort} ${year}, ${hour}:${minuteStr}${ampm} (AEST)`;
}

// 格式化金額到小數點後兩位 (四捨五入)
function formatAmount(value) {
  const num = Number(value) || 0;
  return num.toFixed(2);
}
</script>

<style scoped>
.card {
  position: absolute;
  top: 80px; /* 依實際 UI 調整 */
  left: 0;
  right: 0;
  z-index: 1;
  border-radius: 10px 10px 0px 0px;
  background-color: #fff;
  overflow-x: hidden;
  overflow-y: auto; /* 讓內容可滾動 */
}

/* Loading 畫面 */
.loading-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
}
.spinner {
  width: 64px;
  height: 64px;
  border: 8px solid #e3fceb;
  border-top: 8px solid #00c962;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-top: 30px;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Success 畫面 */
.success-screen {
  margin: 30px;
}
.success-icon {
  font-size: 48px;
  color: #00c962;
  margin-bottom: 15px;
}
.success-title {
  font-family: 'Euclid Square', sans-serif;
  font-weight: 600;
  font-size: 24px;
  color: #051c2c;
  margin-bottom: 15px;
}
.success-amount {
  font-family: 'Euclid Square';
  font-style: normal;
  font-weight: 600;
  font-size: 42px;
  line-height: 53px;
  color: #00C962;
}
.success-date {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 23px;
  text-align: center;
  color: #051C2C;
}
.to-label {
  font-size: 16px;
  color: #666;
}
.to-name {
  font-family: 'Euclid Square';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 30px;
  display: flex;
  align-items: center;
  color: #051C2C;
}
.bank-account-label {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px;
}
.bank-account-value {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 23px;
  display: flex;
  align-items: center;
  color: #051C2C;
}
.fee-label {
  font-size: 16px;
  font-weight: 400;
  color: #666;
  margin-bottom: 5px;
}
.fee-amount {
  font-family: 'Euclid Square';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 30px;
  display: flex;
  align-items: center;
  color: #051C2C;
}

/* Fail 畫面 */
.fail-screen {
  margin: 30px;
}
.fail-icon {
  font-size: 48px;
  color: #ff5353;
  margin-bottom: 15px;
}
.fail-title {
  margin-bottom: 15px;
  font-family: 'Euclid Square';
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 38px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #051C2C;
}
.fail-text {
  font-family: 'Euclid Square';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 30px;
  display: flex;
  align-items: center;
  text-align: center; 
  color: #051C2C;
  margin-bottom: 20px;
}
.contact-info {
  font-family: 'Euclid Square';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 25px;
  color: #051C2C;
}
.contact-time {
  margin-top: 20px;
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 23px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #051C2C;
}

.transaction-title {
  width: auto;
  height: 30px;
  font-family: 'Euclid Square';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
  color: #1e1e2d;
}

.arrow-icon {
  width: 12px;
  height: 20px;
}

.phone-icon {
  margin-right: 20px;
  width: 19px;
  height: 34px;
}

.sms-icon {
  margin-right: 20px;
  width: 26px;
  height: 34px;
}

.footer-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  background: #ffffff;
  box-shadow: 0px -2px 15px rgba(5, 28, 44, 0.15);
  border-radius: 12px 12px 0px 0px;
  z-index: 1;
  min-height: 15vh;
  max-height: 44vh;
}

.page-info {
  font-size: 16px;
  color: #333;
  display: flex;
  align-items: center;
  gap: 4px;
}
.page-input {
  width: 40px;
  height: 30px;
  text-align: center;
  font-size: 16px;
  color: #333;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin: 0 5px;
}
button {
  border: none;
  background: none;
  cursor: pointer;
}
.select-all {
  background-color: #fff;
  border: 1px solid #fff;
  border-radius: 5px;
  font-family: 'Euclid Square';
  font-size: 14px;
  color: #051c2c;
}
.select-all-checkbox {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 18px;
  height: 18px;
  border: 2px solid #00c962;
  border-radius: 3px;
  background-color: #fff;
  cursor: pointer;
  outline: none;
  margin: 0;
}
.select-all-checkbox:checked {
  background-color: #00c962;
}
.select-all-checkbox:checked::after {
  content: '';
  display: block;
  position: relative;
  top: 1px;
  left: 4px;
  width: 5px;
  height: 9px;
  border: solid black;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

/* 針對 disabled checkbox 做反灰 */
.select-all-checkbox[disabled] {
  border-color: #c4c4c4;
  background-color: #c4c4c4;
  border: #00C962 1px solid;
  cursor: not-allowed;
}
.select-all-checkbox[disabled]:checked {
  background-color: #c4c4c4;
  border-color: #c4c4c4;
}


.text-total {
  font-family: 'Euclid Square';
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 38px;
  display: flex;
  align-items: center;
  color: #00C962;
}
.text-from {
  font-family: 'Euclid Square';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 30px;
  display: flex;
  align-items: center;
  color: #051C2C;
}
.note-text {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 14px;
  color: #051c2c;
}
.incorrect-text {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 19px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #051c2c;
}
.bank-account {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 23px;
  color: #051c2c;
}
.withdraw-text {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 23px;
  color: #051c2c;
}
.bank-text {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 23px;
  color: #051c2c;
}

.btn-green {
  background: rgba(0, 201, 98, 1);
  color: black;
  border: none;
  width: 220px;
  height: 40px;
  border-radius: 30px;
  font-size: 14px;
  padding: 8px 24px;
}
.btn-green:hover {
  background-color: #00b452;
}
.btn-step {
  width: 110px;
  font-size: 14px;
}
.btn-ok {
  width: 80vw;
  font-size: 14px;
}
.btn-cancel {
  background-color: #fff;
  color: black;
  width: 100px;
  height: 40px;
  border-radius: 30px;
  border: 1px solid #8476f4;
  font-size: 14px;
  padding: 8px 24px;
}
.btn-cancel:hover {
  background-color: #e6e6ff;
}
.btn-icon {
  width: 13px;
  height: 12px;
}
</style>
